import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FormValueModel} from '../../../value/api/entity/formValue.model';

@Injectable()
export class FormFormSaveComponentService {

    readonly inputChangedFormValue$: Observable<FormFormSaveComponentServiceFormValue> = new BehaviorSubject(undefined);
    readonly changedFormValue$: Observable<FormFormSaveComponentServiceFormValue> = new BehaviorSubject(undefined);
    readonly allCardStates$: Observable<boolean> = new BehaviorSubject(true);

    setChangedValue(changedValue: FormFormSaveComponentServiceFormValue) {
        console.log(['set changed value', changedValue]);
        (this.changedFormValue$ as BehaviorSubject<FormFormSaveComponentServiceFormValue>).next(changedValue);
    }

    setAllCardExpanded(expanded: boolean) {
        (this.allCardStates$ as BehaviorSubject<boolean>).next(expanded);
    }

    setChangedFromInput(value: FormFormSaveComponentServiceFormValue) {
        (this.inputChangedFormValue$ as BehaviorSubject<FormFormSaveComponentServiceFormValue>).next(value);
    }
}

export class FormFormSaveComponentServiceFormValue {
    fieldDefinitionName: string;
    fieldDefinitionId: number;
    value: any;
    valueForRule: any;
}
